import { createStyles } from 'antd-style';

const useStyles = createStyles(() => {
  return {
    'behavior-experiment-container': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: '30px',
    },
    'behavior-experiment--client-selector': {
      width: '250px',
    },
    'behavior-experiment--input': {
      width: '80%',
      marginBottom: '20px',
    },
    'fading-container': {
      animation: 'fadeIn ease 2s',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      alignItems: 'center',
    },
    'behavior-experiment--buttons-container': {
      display: 'flex',
      maxWidth: '250px',
      width: '200px',
      justifyContent: 'space-between',
    },
    'behavior-experiment--image-title': {
      margin: '20px 0',
    },
    'behavior-experiment--title': {
      marginBottom: '20px',
      textAlign: 'center',
    },
    'behavior-experiment--tooltip': {
      minWidth: '50%',
    },
    'behavior-experiments--thoughts-container': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      margin: '25px',
    },
    'behavior-experiment--question-container': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: '20px',
    },
    'behavior-experiments--question-container': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    'behavior-experiments--arrow-icon': {
      marginTop: '20px',
    },
    'behavior-experiments--slider-row': {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-evenly',
    },
  };
});
export default useStyles;
